import biziverse from "./biziverse.png";
import bluedart from "./bluedart.png";
import borzo from "./borzo.png";
import butrix24 from "./butrix24.png";
import clove from "./clove.png";
import dropboz from "./dropboz.png";
import easebuzz from "./easebuzz.png";
import facebookmessenger from "./facebookmessenger.png";
import freshdesk from "./freshdesk.png";
import freshsales from "./freshsales.png";
import gmail from "./gmail.png";
import googleadwords from "./googleadwords.png";
import googlemeet from "./googlemeet.png";
import googlesheet from "./googlesheet.png";
import hubspot from "./hubspot.png";
import instamojo from "./instamojo.png";
import kapture from "./kapture.png";
import knowlarity from "./knowlarity.png";
import leadsquared from "./leadsquared.png";
import magento from "./magento.png";
import mailchimp from "./mailchimp.png";
import msg91 from "./msg91.png";
import myoperator from "./myoperator.png";
import neuralspace from "./neuralspace.png";
import outlook from "./outlook.png";
import paramantra from "./paramantra.png";
import payu from "./payu.png";
import phonepe from "./phonepe.png";
import razorpay from "./razorpay.png";
import salesforce from "./salesforce.png";
import schoolknot from "./schoolknot.png";
import selldo from "./selldo.png";
import shiprocket from "./shiprocket.png";
import shopify from "./shopify.png";
import slack from "./slack.png";
import stripe from "./stripe.png";
import surey2connect from "./surey2connect.png";
import textlocal from "./textlocal.png";
import webhook from "./webhook.png";
import whatsappcatalog from "./whatsappcatalog.png";
import whatsappcommerce from "./whatsappcommerce.png";
import woocommerce from "./woocommerce.png";
import wordpress from "./wordpress.png";
import zapier from "./zapier.png";
import zendesk from "./zendesk.png";
import zohocrm from "./zohocrm.png";
import zohodesk from "./zohodesk.png";
import zoom from "./zoom.png";

const integrationImages = [
  { name: "Biziverse", src: biziverse },
  { name: "Bluedart", src: bluedart },
  { name: "Borzo", src: borzo },
  { name: "Butrix24", src: butrix24 },
  { name: "Clove", src: clove },
  { name: "Dropboz", src: dropboz },
  { name: "Easebuzz", src: easebuzz },
  { name: "Facebook Messenger", src: facebookmessenger },
  { name: "Freshdesk", src: freshdesk },
  { name: "Freshsales", src: freshsales },
  { name: "Gmail", src: gmail },
  { name: "Google Adwords", src: googleadwords },
  { name: "Google Meet", src: googlemeet },
  { name: "Google Sheet", src: googlesheet },
  { name: "HubSpot", src: hubspot },
  { name: "Instamojo", src: instamojo },
  { name: "Kapture", src: kapture },
  { name: "Knowlarity", src: knowlarity },
  { name: "LeadSquared", src: leadsquared },
  { name: "Magento", src: magento },
  { name: "Mailchimp", src: mailchimp },
  { name: "MSG91", src: msg91 },
  { name: "MyOperator", src: myoperator },
  { name: "Neuralspace", src: neuralspace },
  { name: "Outlook", src: outlook },
  { name: "Paramantra", src: paramantra },
  { name: "PayU", src: payu },
  { name: "PhonePe", src: phonepe },
  { name: "Razorpay", src: razorpay },
  { name: "Salesforce", src: salesforce },
  { name: "Schoolknot", src: schoolknot },
  { name: "SellDo", src: selldo },
  { name: "Shiprocket", src: shiprocket },
  { name: "Shopify", src: shopify },
  { name: "Slack", src: slack },
  { name: "Stripe", src: stripe },
  { name: "Surey2Connect", src: surey2connect },
  { name: "TextLocal", src: textlocal },
  { name: "Webhook", src: webhook },
  { name: "WhatsApp Catalog", src: whatsappcatalog },
  { name: "WhatsApp Commerce", src: whatsappcommerce },
  { name: "WooCommerce", src: woocommerce },
  { name: "WordPress", src: wordpress },
  { name: "Zapier", src: zapier },
  { name: "Zendesk", src: zendesk },
  { name: "Zoho CRM", src: zohocrm },
  { name: "Zoho Desk", src: zohodesk },
  { name: "Zoom", src: zoom },
];

export default integrationImages;
